module.exports = __webpack_public_path__ + "img/Hybrid Charge.fd8add4f.png";